import env from 'env';
import useScript from 'hooks/useScript';

const useInitInjectScripts = (shouldAddRecaptcha) => {
  const isProduction = process.env.NODE_ENV === 'production';

  const googleMapsSrc = `https://maps.googleapis.com/maps/api/js?key=${env.GOOGLE_MAPS_API_KEY}&libraries=places`;
  const recaptchaSrc =
    shouldAddRecaptcha && isProduction
      ? `https://www.google.com/recaptcha/api.js?render=${env.RECAPTCHA_SITE_KEY}`
      : null;

  useScript({ async: true, src: googleMapsSrc });
  useScript({ async: true, src: recaptchaSrc });
};

export default useInitInjectScripts;
